interface TitleComponentProps {
  string: string
  children: any
}
export default function TitleComponent({ children }: TitleComponentProps) {
  // this is used because the column selector needs the title as a string else the styling will not be aligned 💅
  return children
}
